import * as theme from "./TimelineDotCircle.css";

interface TimelineDotCircleProps {
    children: React.ReactNode;
}
export function TimelineDotCircle({ children }: TimelineDotCircleProps) {
    return <div className={theme.root}>{children}</div>;
}
